<template>
    <career-form/>
</template>

<script>
    import CareerForm from './Form';

    export default {
        name:       'CareerDetail',
        components: {
            CareerForm
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/career/Detail.vue